export const TITLE = 'Account';
export const GENRE_TEXT = 'Favorite Genres';
// export const GENRE_SUB_TEXT = 'Your three favorite genres';

// ============================
// TODO: Remove after private beta: https://app.shortcut.com/tone-birds/story/471/remove-genre-restriction-for-fans-after-private-beta
export const GENRE_SUB_TEXT =
  'Editing your genres have been disabled for a private beta test';
// ============================
export const PROFILE_SAVED = 'Your profile has been saved';
